<template>
  <div class="notice-detail">
    <div>
      <el-form
        class="wrapper"
        ref="form"
        :model="form"
        style="margin-top:10px"
        v-if="options.length > 0"
      >
        <el-form-item label="切换单位：">
          <el-select v-model="form.value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.supCode"
              :label="item.supName"
              :value="item.supCode"
              @click.native="changeCompany(item)"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!--采购公告-->
      <template v-for="(item1, index1) in noticeData">
        <div class="notice-class" :key="index1">
          <div class="wrapper">
            <div class="ccui-clearfix wrapper">
              <div class=" fl">
                <p class="title fl ">{{ item1.noticeTitle }}</p>
              </div>
              <el-link
                :underline="false"
                type="info"
                class="fr view-all"
                @click="handleViewAll(item1.type)"
                >{{ $t("page.content.MoreAndMore") }} ></el-link
              >
            </div>
            <div class="notice-detail-list mt15 ccui-clearfix">
              <template v-for="(item, index) in item1.rows">
                <div
                  :class="
                    `notice-detail-box mb20 fl ${(index + 1) % 5 !== 0 &&
                      'mr20'}`
                  "
                  :key="index"
                >
                  <div
                    class="notice-detail-box-out"
                    v-if="item.isEmpty !== 1"
                    @click="handleView(item)"
                  >
                    <notice-item-block :data="item"></notice-item-block>
                  </div>
                  <div class="empty-content" v-else>
                    {{ $t("page.content.blockNoData") }}
                  </div>
                  <notice-item-bottom-btn :item="item"></notice-item-bottom-btn>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>

      <!--战略合作伙伴-->
      <!--      <div-->
      <!--        :class="-->
      <!--          `notice-class ${-->
      <!--            noticeData % 2 === 0 ? 'notice-class-1' : 'notice-class-2'-->
      <!--          }`-->
      <!--        "-->
      <!--      >-->
      <!--        <div class="wrapper">-->
      <!--          <div class="title">战略合作伙伴</div>-->
      <!--          <div class="notice-detail-list mt15 ccui-clearfix">-->
      <!--            <template v-for="(item, index) in cardList">-->
      <!--              <div-->
      <!--                :key="index"-->
      <!--                :class="`box-card fl mb20 ${(index + 1) % 5 !== 0 && 'mr20'}`"-->
      <!--              >-->
      <!--                <img class="card-img" src="" />-->
      <!--              </div>-->
      <!--            </template>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { listSupBidNotice } from "@/app/shop/api/shopping";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
import noticeItemBottomBtn from "@/app/shop/components/noticeItemBottomBtn";
import Cookies from "js-cookie";
export default {
  name: "noticeItem",
  mixins: [mixinHomePage],
  components: {
    noticeItemBlock,
    noticeItemBottomBtn
  },
  data() {
    return {
      noticeData: [],
      cardList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      // supInfo:
      //   this.$store.state.user.supInfo ||
      //   JSON.parse(localStorage.getItem("supInfo")) ||
      //   {},
      supInfo: this.$store.state.user.supInfo || {},
      options: [],
      form: {
        value: ""
      },
      supName: "" //分包商名称
    };
  },
  created() {},
  mounted() {
    let supInfo = null;
    if (
      this.supInfo &&
      this.supInfo.getSupInfoByLoginInfoRspBOList.length > 1
    ) {
      this.options = this.supInfo.getSupInfoByLoginInfoRspBOList;
      this.form.value = this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode;
      this.supName = this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName;
      supInfo = {
        corpSupSituation: "",
        getSupInfoByLoginInfoRspBOList: [
          {
            corpSupSituation: "",
            getSupInfoByLoginInfoRspBOList: [],
            isOverseas: 0,
            secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
              .secretAgentId,
            purSupFlag: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
              .purSupFlag,
            supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
            supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName,
            supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId
          }
        ],
        isOverseas: 0,
        secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
          .secretAgentId,
        purSupFlag: this.supInfo.getSupInfoByLoginInfoRspBOList[0].purSupFlag,
        supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
        supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName,
        supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId
      };
      localStorage.supInfo = JSON.stringify(supInfo);
      this.$store.dispatch("user/setsupinfo", supInfo);
      this.$emit("getSupCode", this.form.value);
    } else {
      this.$emit("getSupCode", this.supInfo.supCode);
    }
    this.init();
  },
  activated() {
    let supInfo = null;
    if (
      this.supInfo &&
      this.supInfo.getSupInfoByLoginInfoRspBOList.length > 1
    ) {
      this.options = this.supInfo.getSupInfoByLoginInfoRspBOList;
      this.form.value = this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode;
      this.supName = this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName;
      supInfo = {
        corpSupSituation: "",
        getSupInfoByLoginInfoRspBOList: [
          {
            corpSupSituation: "",
            getSupInfoByLoginInfoRspBOList: [],
            isOverseas: 0,
            secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
              .secretAgentId,
            purSupFlag: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
              .purSupFlag,
            supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
            supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName,
            supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId
          }
        ],
        isOverseas: 0,
        secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
          .secretAgentId,
        purSupFlag: this.supInfo.getSupInfoByLoginInfoRspBOList[0].purSupFlag,
        supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
        supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName,
        supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId
      };
      localStorage.supInfo = JSON.stringify(supInfo);

      this.$store.dispatch("user/setsupinfo", supInfo);
      this.$emit("getSupCode", this.form.value);
    } else {
      this.$emit("getSupCode", this.supInfo.supCode);
    }
    this.init();
  },
  deactivated() {
    this.noticeData = [];
  },
  methods: {
    async init() {
      //1-> 公开采购  5->询价采购  6->竞争谈判
      let arr = [
        this.getNoticeList({
          noticeType: 1
        })
      ];
      if (Cookies.get("access_token")) {
        arr.push(
          this.getNoticeList({
            noticeType: 2
          }),
          this.getNoticeList({
            noticeType: 5
          }),
          this.getNoticeList({
            noticeType: 6
          })
        );
      }
      await Promise.all(arr).then(res => {
        if (res && res[0] && res[0].rows.length > 0) {
          this.noticeData.push({
            noticeTitle: this.$t("page.content.labelMenu6"),
            type: "1",
            rows: res[0].rows
          });
        }
        if (res && res[1] && res[1].rows.length > 0) {
          this.noticeData.push({
            noticeTitle: this.$t("page.content.labelMenu4"), //邀请公告
            type: "2",
            rows: res[1].rows
          });
        }
        if (res && res[2] && res[2].rows.length > 0) {
          this.noticeData.push({
            noticeTitle: this.$t("page.content.labelMenu7"),
            type: "5",
            rows: res[2].rows
          });
        }
        if (res && res[3] && res[3].rows.length > 0) {
          this.noticeData.push({
            noticeTitle: this.$t("page.content.labelMenu8"),
            type: "6",
            rows: res[3].rows
          });
        }
      });
    },
    getNoticeList(obj) {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      return new Promise(resolve => {
        let params = {
          isShowPageLoading: true,
          noticeStatusEndFlag: "1",
          pageNo: 1,
          pageSize: 10,
          supCodeList: this.form.value == "" ? supCodeList : [this.form.value],
          // this.form.value == "" ? supCodeList  : [this.form.value],
          supCode:
            this.form.value == "" ? this.supInfo.supCode : this.form.value
          // this.form.value == "" ? this.supInfo.supCode  : this.form.value
        };
        if (
          Cookies.get("language") !== undefined &&
          Cookies.get("language") !== "zh-cn"
        ) {
          params.overseasSupFlag = 1;
        }
        Object.assign(params, obj);
        listSupBidNotice(params).then(res => {
          if (res.data.code === "0") {
            if (res.data.data.rows.length > 0) {
              this.noticeData = [];
              if (res.data.data.rows.length < 5) {
                for (let i = res.data.data.rows.length; i < 5; i++) {
                  res.data.data.rows.push({
                    isEmpty: 1
                  });
                }
              } else if (
                res.data.data.rows.length < 10 &&
                res.data.data.rows.length > 5
              ) {
                for (let i = res.data.data.rows.length; i < 10; i++) {
                  res.data.data.rows.push({
                    isEmpty: 1
                  });
                }
              }
            }
            // if (obj.noticeType == 1) {
            //   res.data.data.rows.forEach(el => {
            //     el.supCode = this.supInfo.supCode;
            //     el.supName = this.supInfo.supName;
            //   });
            // } else {

            if (this.form.value !== "") {
              res.data.data.rows.forEach(el => {
                //多个分包商身份里，把选择的分包商code传到列表里
                // if (el.isJoinFlag == "2") {
                el.supCode = this.form.value;
                el.supName = this.supName;
                // }
              });
            } else {
              if (obj.noticeType == 1) {
                res.data.data.rows.forEach(el => {
                  el.supCode = this.supInfo.supCode;
                  el.supName = this.supInfo.supName;
                });
              }
            }
            // }

            resolve(res.data.data);
          }
        });
      });
    },

    handleViewAll(type) {
      let url = this.$router.resolve({
        path: "/searchList",
        query: {
          type: type,
          supCode:
            this.form.value == "" ? this.supInfo.supCode : this.form.value
        }
      });
      window.open(url.href, "_blank");
    },
    changeCompany(item) {
      this.form.value = item.supCode;
      this.supName = item.supName;
      this.$emit("getSupCode", this.form.value);

      let supInfo = {
        corpSupSituation: "",
        getSupInfoByLoginInfoRspBOList: [
          {
            corpSupSituation: "",
            getSupInfoByLoginInfoRspBOList: [],
            isOverseas: 0,
            secretAgentId: item.secretAgentId,
            purSupFlag: item.purSupFlag,
            supCode: item.supCode,
            supName: item.supName,
            supinfoId: item.supinfoId
          }
        ],
        isOverseas: 0,
        secretAgentId: item.secretAgentId,
        purSupFlag: item.purSupFlag,
        supCode: item.supCode,
        supName: item.supName,
        supinfoId: item.supinfoId
      };
      localStorage.supInfo = JSON.stringify(supInfo);
      this.$store.dispatch("user/setsupinfo", supInfo);
      this.noticeData = [];
      this.init();
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.empty-content {
  background-color: #fafafa;
  line-height: 312px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #cccccc;
}
</style>
